export default __webpack_public_path__ + "static/media/madu.29263258.png";